import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowReviewDetail", inputValue, ShowReviewDetailSuccess);
    }, []);	
	
    const ShowReviewDetailSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>	
			<Accordion>
			  <Accordion.Item eventKey="0">
				<Accordion.Header>اطلاعات پایه</Accordion.Header>
				<Accordion.Body>
					<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
						<tbody>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">مامور بازدید:</b> {getServiceResult.Visitor}</td>
								<td colspan="3" className="text-right"><b class="b1">تاریخ بازدید:</b> {getServiceResult.ViewDate}</td>
								<td colspan="3" className="text-right"><b class="b1">نوبت بازدید:</b> {getServiceResult.InspectionNumber}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1"> نوع زمین: </b> {getServiceResult.LandUse}</td>
								<td colspan="3" className="text-right"><b class="b1">مرحله ساختمانی:  </b> {getServiceResult.BuildingUsage}</td>
								<td colspan="3" className="text-right"><b class="b1">نوع اسکلت: </b> {getServiceResult.BuildingStructure}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">مساحت زمین: </b> {getServiceResult.ParcelArea}</td>
								<td colspan="3" className="text-right"><b class="b1">تعداد طبقات زیر زمین: </b> {getServiceResult.BasementFloorCount}</td>
								<td colspan="3" className="text-right"><b class="b1">تعداد طبقات سایر: </b> {getServiceResult.FloorCount}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">وضعیت ساختمان: </b> {getServiceResult.BuildingStage}</td>
								{getServiceResult.IsDisplayableFirstReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.FirstReviewTitle}: </b> {getServiceResult.FirstReviewValue}</td>}
								{getServiceResult.IsDisplayableSecondReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.SecondReviewTitle}: </b> {getServiceResult.SecondReviewValue}</td>}
							</tr>
							<tr>
								{getServiceResult.IsDisplayableThirdReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.ThirdReviewTitle}: </b> {getServiceResult.ThirdReviewValue}</td>}
								{getServiceResult.IsDisplayableFourthReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.FourthReviewTitle}: </b> {getServiceResult.FourthReviewValue}</td>}
								<td colspan="3" className="text-right"><b class="b1">وضعیت خلاف: </b> {getServiceResult.ContradictionStatus ? 'دارد':'ندارد'}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">شماره آخرین پرونده: </b> {getServiceResult.LastConstructNumber}</td>
								<td colspan="3" className="text-right"><b class="b1">شماره آخرین عدم خلاف: </b> {getServiceResult.LastNonContradictionNumber}</td>
								<td colspan="3" className="text-right"><b class="b1">شماره آخرین پایانکار: </b> {getServiceResult.LastCompletionNumber}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین پروانه: </b> {getServiceResult.LastConstructDate}</td>
								<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین عدم خلاف: </b> {getServiceResult.LastNonContradictionDate}</td>
								<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین پایان کار: </b> {getServiceResult.LastCompletionDate}</td>
							</tr>	
							<tr>
								<td colspan="3" className="text-right"><b class="b1">تاریخ ساخت بنا: </b> {getServiceResult.BuildingYear}</td>
								<td colspan="3" className="text-right"><b class="b1">مصالح ساختمانی: </b> {getServiceResult.BuildingMaterials}</td>
								<td colspan="3" className="text-right"><b class="b1">مهندس ناظر: </b> {getServiceResult.SupervisorEngineer}</td>
							</tr>		
							<tr>
								<td colspan="9" className="text-right"><b class="b1">  توضیحات یازدید:</b> <br/> {getServiceResult.ReviewDescription} </td>
							</tr>									
						</tbody>
					</table>
				</Accordion.Body>
			  </Accordion.Item>
			  <Accordion.Item eventKey="1">
				<Accordion.Header>اطلاعات جهت و ابعاد ملک</Accordion.Header>
				<Accordion.Body>
					<GridControl
						data={Object.keys(getServiceResult).length > 0 && getServiceResult.DimentionDetailsInfoList}
						customHeaders={{
							"DimensionsSide": "جهت",
							"LengthSide": "طول ضلع",
							"LimitTitle": "حد",
							"CrossWidth": "عرض گذر",
							"StreetName": "نام معبر",
							"Description": "پخ و قوس"
						}}		
					/>						
				</Accordion.Body>
			  </Accordion.Item>
			  <Accordion.Item eventKey="2">
				<Accordion.Header>اطلاعات بناهای موجود و مجاز</Accordion.Header>
				<Accordion.Body className="responseTable">
					<p class="text-primary">وضع موجود:</p>
					<GridControl
						data={Object.keys(getServiceResult).length > 0 && getServiceResult.AllowedUsageInfoList}
						customHeaders={{
							"FloorTitle": "طبقه",
							"PrimaryUsedTitle": "نوع استفاده اصلی",
							"SecondaryUsedTitle": "نوع استفاده فرعی",
							"Unit": "واحد",
							"Area": "مساحت",
							"EntryNumber": "تعداد دهانه",
							"EntryLength": "طول دهانه",
							"EntryHeight": "ارتفاع دهانه",
						}}		
					/>						
					<br/>
					<p class="text-primary">وضع مجاز:</p>
					<GridControl
						data={Object.keys(getServiceResult).length > 0 && getServiceResult.ExistUsageInfoList}
						customHeaders={{
							"FloorTitle": "طبقه",
							"PrimaryUsedTitle": "نوع استفاده اصلی",
							"SecondaryUsedTitle": "نوع استفاده فرعی",
							"Unit": "واحد",
							"Area": "مساحت",
							"EntryNumber": "تعداد دهانه",
							"EntryLength": "طول دهانه",
							"EntryHeight": "ارتفاع دهانه",
						}}		
					/>						
					<br/>
					<p class="text-primary">اختلاف وضع موجود و مجاز:</p>
					<GridControl
						data={Object.keys(getServiceResult).length > 0 && getServiceResult.DifferenceUsageInfoList.map((item, index) => ({ ...item, ID: index + 1 }))}
						customHeaders={{
							"ID": "ردیف",
							"FloorTitle": "طبقه",
							"PrimaryUsedTitle": "نوع استفاده اصلی",
							"SecondaryUsedTitle": "نوع استفاده فرعی",
							"Unit": "واحد",
							"Area": "مساحت"
						}}		
					/>						
				</Accordion.Body>
			  </Accordion.Item>			  
			</Accordion>			
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
